import request from "root/js/request";

export const getCostsByZoneDynamic = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  advert_id__in,
  type__in,
  ...rest
}) => {
  const response = await request({
    url: "/api/analytics/advert_zone_costs/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      advert_id__in,
      type__in,
      ...rest,
    },
  });
  return response.data;
};
